// URL do portal (sptech.ia.portal.ui), em outra origem: login, barra de navegação
// (<sptech-app-nav>) e logout são dele. Build-time (NEXT_PUBLIC_*). Vazia, o app
// segue sem a barra e loga direto pela Microsoft, como com o portal fora do ar.
export const PORTAL_URL = (process.env.NEXT_PUBLIC_PORTAL_IA_URL ?? "").replace(/\/$/, "");

// Caminho do portal ("/logout") → URL absoluta.
export function portalUrl(path: string) {
  return `${PORTAL_URL}${path}`;
}

export type PortalUser = { name: string; email: string; photo: string | null };

declare global {
  interface Window {
    sptechPortal?: { session: Promise<PortalUser | null> };
  }
}

// Quem está logado no portal, decidido pela <sptech-app-nav> (nav.js do portal):
//   usuário → o e-mail serve de login_hint para o loginRedirect deste app (sem tela);
//   null    → portal fora do ar ou sem resposta: login direto com a Microsoft;
//   pendente→ a barra está levando ao login do portal (não há o que fazer aqui).
// Espera o nav.js carregar; se ele falhar (PortalNav avisa) ou não carregar a tempo, null.
const NAV_TIMEOUT_MS = 15_000;

export function portalSession(): Promise<PortalUser | null> {
  return new Promise((resolve) => {
    if (window.sptechPortal) {
      void window.sptechPortal.session.then(resolve);
      return;
    }
    const timer = setTimeout(() => resolve(null), NAV_TIMEOUT_MS);
    document.addEventListener(
      "sptech-portal:ready",
      () => {
        clearTimeout(timer);
        void window.sptechPortal?.session.then(resolve);
      },
      { once: true },
    );
    document.addEventListener("sptech-portal:unavailable", () => resolve(null), { once: true });
  });
}
